<template>
  <div class="container">
    <el-card shadow="never" header="统一发信配置（SMTP）">
      <el-form ref="smtpForm" :model="smtp" label-width="160px" v-loading="loading">
        <el-form-item label="服务器地址">
          <el-input v-model="smtp.host" placeholder="smtp.example.com" />
        </el-form-item>
        <el-form-item label="端口">
          <el-input type="number" v-model="smtp.port" />
        </el-form-item>
        <el-form-item label="账号">
          <el-input v-model="smtp.user" />
        </el-form-item>
        <el-form-item label="密码">
          <el-input v-model="smtp.password" placeholder="不修改请留空" />
        </el-form-item>
        <el-form-item label="发件人地址">
          <el-input v-model="smtp.from" />
        </el-form-item>
        <el-form-item label="发件人名称">
          <el-input v-model="smtp.from_name" />
        </el-form-item>
        <el-form-item label="加密方式">
          <el-select v-model="smtp.encryption">
            <el-option label="ssl" value="ssl" />
            <el-option label="tls" value="tls" />
            <el-option label="none" value="none" />
          </el-select>
        </el-form-item>
        <el-form-item label="告警 Webhook Key">
          <el-input v-model="alert.wechat_webhook_key" placeholder="不修改请留空" />
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="saveCommon">保存</el-button>
        </el-form-item>
      </el-form>
    </el-card>

    <el-card shadow="never" header="邮件类型配置" style="margin-top: 16px;">
      <el-tabs v-model="activeType">
        <el-tab-pane
          v-for="item in typeCatalog"
          :key="item.type"
          :label="item.label"
          :name="item.type"
        >
          <el-form :model="types[item.type]" label-width="160px" v-loading="loading">
            <el-form-item label="触发状态">
              <div v-if="triggerInfo[item.type]" class="trigger-info">
                <span>调度心跳：
                  <b :class="{ err: triggerInfo[item.type].tick_delay_seconds < 0 || triggerInfo[item.type].tick_delay_seconds > 180 }">
                    {{ triggerInfo[item.type].last_tick_date || '无' }}
                    <template v-if="triggerInfo[item.type].tick_delay_seconds >= 0">（{{ triggerInfo[item.type].tick_delay_seconds }} 秒前）</template>
                  </b>
                  <el-tag v-if="triggerInfo[item.type].tick_delay_seconds < 0 || triggerInfo[item.type].tick_delay_seconds > 180" size="mini" type="danger">调度可能已停止</el-tag>
                </span>
                <span>下次触发：<b>{{ triggerInfo[item.type].next_trigger_date || '—' }}</b></span>
                <span v-if="triggerInfo[item.type].next_stat_date">本次统计日：<b>{{ triggerInfo[item.type].next_stat_date }}</b></span>
                <span>最近一次：<b>{{ triggerInfo[item.type].last_created_date || '—' }}</b>
                  <el-tag v-if="triggerInfo[item.type].last_status" size="mini">
                    {{ statusMap[triggerInfo[item.type].last_status] || triggerInfo[item.type].last_status }}
                  </el-tag>
                </span>
                <span v-if="triggerInfo[item.type].last_biz_key" class="biz-key">{{ triggerInfo[item.type].last_biz_key }}</span>
                <span v-if="triggerInfo[item.type].last_error" class="err">{{ triggerInfo[item.type].last_error }}</span>
              </div>
            </el-form-item>
            <el-form-item label="启用">
              <el-switch v-model="types[item.type].enabled" />
            </el-form-item>
            <el-form-item label="发送时间(东八区)">
              <el-input v-model="types[item.type].schedule.time" placeholder="HH:mm" style="width: 160px;" />
            </el-form-item>
            <el-form-item label="收件人(to)">
              <el-input type="textarea" :rows="2" v-model="toText[item.type]" placeholder="多个邮箱用逗号分隔" />
            </el-form-item>
            <el-form-item label="抄送(cc)">
              <el-input type="textarea" :rows="2" v-model="ccText[item.type]" placeholder="多个邮箱用逗号分隔" />
            </el-form-item>
            <el-form-item label="重试次数">
              <el-input type="number" v-model="types[item.type].retry.max_attempts" style="width: 160px;" />
            </el-form-item>
            <el-form-item label="重试间隔(分钟)">
              <el-input type="number" v-model="types[item.type].retry.base_minutes" style="width: 120px;" />
              <span style="margin: 0 8px;">×</span>
              <el-input type="number" v-model="types[item.type].retry.multiplier" style="width: 120px;" />
              <span style="margin: 0 8px;">上限</span>
              <el-input type="number" v-model="types[item.type].retry.max_minutes" style="width: 120px;" />
            </el-form-item>
            <el-form-item v-if="item.type === questionnaireType" label="统计日">
              <el-select v-model="types[item.type].stat_offset_days" style="width: 200px;">
                <el-option
                  v-for="opt in statOffsetOptions"
                  :key="opt.value"
                  :label="opt.label"
                  :value="opt.value"
                />
              </el-select>
            </el-form-item>
            <el-form-item v-if="item.type === questionnaireType" label="问卷模版 ID">
              <el-input v-model="templateText[item.type]" placeholder="多个 ID 用逗号分隔" />
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="saveType(item.type)">保存</el-button>
            </el-form-item>
          </el-form>
        </el-tab-pane>
      </el-tabs>
    </el-card>
  </div>
</template>

<script>
import {
  getEmailCommon, setEmailCommon, getEmailType, setEmailType
} from '@/api/email'

export default {
  name: 'EmailSetting',
  data () {
    return {
      loading: false,
      questionnaireType: 'stat.questionnaire',
      activeType: 'stat.questionnaire',
      typeCatalog: [],
      smtp: { host: '', port: 465, user: '', password: '', from: '', from_name: '', encryption: 'ssl' },
      alert: { wechat_webhook_key: '' },
      types: {},
      triggerInfo: {},
      statusMap: {
        pending: '待发送',
        sending: '发送中',
        success: '成功',
        retry_wait: '待重试',
        failed: '失败',
        exhausted: '重试耗尽',
        canceled: '已取消'
      },
      statOffsetOptions: [],
      toText: {},
      ccText: {},
      templateText: {}
    }
  },
  created () {
    this.statOffsetOptions = [{ value: 0, label: '今天' }]
    for (let i = 1; i <= 7; i++) {
      this.statOffsetOptions.push({ value: i, label: i === 1 ? '前1天（昨天）' : `前${i}天` })
    }
    this.loadCommon()
  },
  methods: {
    // 统一解析响应：兼容 {data:{...}} 包裹与直接返回
    unwrap (res) {
      const body = res && res.data ? res.data : res
      return body && body.data ? body.data : body
    },
    async loadCommon () {
      this.loading = true
      try {
        const res = await getEmailCommon()
        const data = this.unwrap(res) || {}
        this.smtp = Object.assign(this.smtp, data.smtp || {})
        this.alert = Object.assign(this.alert, data.alert || {})
        // 掩码不回显，留空即不修改
        if (this.smtp.password === '******') this.smtp.password = ''
        if (this.alert.wechat_webhook_key === '******') this.alert.wechat_webhook_key = ''
        this.typeCatalog = data.type_catalog || []
        if (this.typeCatalog.length && !this.types[this.activeType]) {
          this.activeType = this.typeCatalog[0].type
        }
        for (const item of this.typeCatalog) {
          await this.loadType(item.type)
        }
      } finally {
        this.loading = false
      }
    },
    async loadType (type) {
      const res = await getEmailType(type)
      const body = this.unwrap(res)
      const config = body.config || {}
      this.$set(this.triggerInfo, type, body.trigger || {})
      this.$set(this.types, type, config)
      this.$set(this.toText, type, (config.to || []).join(','))
      this.$set(this.ccText, type, (config.cc || []).join(','))
      this.$set(this.templateText, type, (config.template_ids || []).join(','))
    },
    async saveCommon () {
      await setEmailCommon({ smtp: this.smtp, alert: this.alert })
      this.$message.success('保存成功')
      this.smtp.password = ''
      this.loadCommon()
    },
    async saveType (type) {
      const config = Object.assign({}, this.types[type])
      config.to = this.splitMails(this.toText[type])
      config.cc = this.splitMails(this.ccText[type])
      if (type === this.questionnaireType) {
        config.template_ids = this.templateText[type].split(',').map(v => parseInt(v, 10)).filter(v => v > 0)
      }
      await setEmailType(type, config)
      this.$message.success('保存成功')
      this.loadType(type)
    },
    splitMails (text) {
      return (text || '').split(',').map(v => v.trim()).filter(v => v !== '')
    }
  }
}
</script>

<style scoped>
.trigger-info span {
  display: inline-block;
  margin-right: 16px;
  color: #606266;
}
.trigger-info .biz-key {
  color: #909399;
  font-size: 12px;
}
.trigger-info .err {
  color: #f56c6c;
}
</style>
